export default __webpack_public_path__ + "static/8-13dc737de68c3f6c1e16db0ab906e5fd.jpg";